export const en = {
  // Navigation
  'nav.home': 'Home',
  'nav.projects': 'Services',
  'nav.timeline': 'Timeline',
  'nav.team': 'Team',
  'nav.contact': 'Contact',
  'nav.admin': 'Dashboard',
  'nav.digitalTeam': 'RS Digital Team',

  // Hero Section
  'hero.est': 'EST. 2021 | RS Team',
  'hero.brand': 'RED SHADOWS | RS',
  'hero.title': 'RED SHADOWS | RS',
  'hero.subtitle': 'Passionate and innovative software development team committed to building powerful, lightweight, and efficient solutions',
  'hero.cta': 'Explore Services',

  // Sections
  'section.projects': 'Our Expertise',
  'section.tech': 'Technologies',
  'section.timeline': 'Our Journey',
  'section.team': 'Meet the Team',
  'section.faq': 'Frequently Asked Questions',
  'section.contact': 'Get in Touch',

  // Admin
  'admin.login': 'Admin Portal',
  'admin.username': 'Username',
  'admin.password': 'Password',
  'admin.access': 'Access Dashboard',
  'admin.credentials': 'Please enter your credentials to continue',
  'admin.invalid': 'Invalid credentials. Please try again',
  'admin.backLogin': 'Return',
  'admin.dashboard': 'Admin Dashboard',
  'admin.manage': 'Manage your digital content efficiently',
  'admin.back': 'Back to Website',
  'admin.logout': 'Sign Out',
  'admin.switchLanguage': 'Switch Language',
  'admin.addProject': 'New Service',
  'admin.addTeam': 'New Member',
  'admin.addTimeline': 'New Milestone',
  'admin.editProject': 'Edit Service',
  'admin.editTeam': 'Edit Member',
  'admin.editTimeline': 'Edit Milestone',
  'admin.addFaq': 'New FAQ',
  'admin.update': 'Save Changes',
  'admin.edit': 'Edit',
  'admin.delete': 'Delete',
  'admin.cancel': 'Cancel',
  'admin.confirmDelete': 'Confirm Action',
  'admin.deleteWarning':
    'Are you sure you want to permanently delete this item? This action cannot be reversed',

  // Forms
  'form.title': 'Title',
  'form.desc': 'Description',
  'form.image': 'Cover Image',
  'form.category': 'Category Tag',
  'form.name': 'Full Name',
  'form.role': 'Position / Role',
  'form.year': 'Year',
  'form.month': 'Month',
  'form.technologies': 'Tech Stack',
  'form.upload': 'Drag & Drop or Click to Upload',
  'form.submit': 'Create Item',
  'form.features': 'Key Features',
  'form.bttnType': 'Action Button',
  'form.linkUrl': 'Destination URL',
  'form.email': 'Email',
  'form.github': 'Github',
  'form.discord': 'Discord',
  'form.whatsapp': 'WhatsApp',

  // Validation
  'validation.required': 'Please fill in all required fields',
  'validation.imageRequired': 'Cover image is required',
  'validation.required.titleEn': 'English Title is required',
  'validation.required.titleAr': 'Arabic Title is required',
  'validation.required.descriptionEn': 'English Description is required',
  'validation.required.descriptionAr': 'Arabic Description is required',
  'validation.required.nameEn': 'English Name is required',
  'validation.required.nameAr': 'Arabic Name is required',
  'validation.required.roleEn': 'English Role is required',
  'validation.required.roleAr': 'Arabic Role is required',
  'validation.required.year': 'Year is required',

  // Placeholders
  'placeholder.service': 'e.g. Web App Development',
  'placeholder.tech': 'e.g. React, TypeScript, Node.js',
  'placeholder.github': 'e.g. username',
  'placeholder.discord': 'e.g. 145608354495070208',
  'placeholder.whatsapp': 'e.g. +966 50 123 4567',
  'placeholder.email': 'e.g. name@example.com',
  'placeholder.year': 'e.g. 2024',
  'placeholder.month': 'e.g. JAN',
  'placeholder.title': 'e.g. Modern E-Commerce Platform',
  'placeholder.name': 'e.g. Sarah Connor',
  'placeholder.role': 'e.g. Lead Designer',
  'placeholder.descEn': 'e.g. A comprehensive solution for online retail...',
  'placeholder.descAr': 'e.g. A comprehensive solution for online retail...',
  'placeholder.milestoneDesc': 'e.g. Reached 100k users milestone...',
  'placeholder.features': 'e.g. Fast, Secure, Scalable',
  'placeholder.link': 'e.g. https://example.com',

  // Options
  'option.noButton': 'None',
  'option.visitSite': 'Website Link',
  'option.visitSource': 'Source Code',

  // Footer
  'footer.rights': 'All Rights Reserved',
  'footer.madeWith': 'Crafted with',
  'footer.byTeam': 'by RED SHADOWS | RS',

  // Months
  'month.jan': 'JAN',
  'month.feb': 'FEB',
  'month.mar': 'MAR',
  'month.apr': 'APR',
  'month.may': 'MAY',
  'month.jun': 'JUN',
  'month.jul': 'JUL',
  'month.aug': 'AUG',
  'month.sep': 'SEP',
  'month.oct': 'OCT',
  'month.nov': 'NOV',
  'month.dec': 'DEC',

  // Contact
  'contact.emailTitle': 'Email Us',
  'contact.emailDesc': 'We aim to respond within 24 hours',
  'contact.discordTitle': 'Community',
  'contact.discordDesc': 'Join our developer community on Discord',
  'contact.send': 'Send Message',
  'contact.visitSite': 'Visit Website',
  'contact.visitSource': 'View Source',
  'contact.emailLabel': 'Your Email Address',
  'contact.sent': 'Message Sent Successfully!',
  'contact.failed': 'Submission Failed. Please try again',
  'contact.joinServer': 'Join Server',

  // Language
  'lang.enCode': 'EN',
  'lang.arCode': 'AR',

  // Errors
  'error.404.title': '404',
  'error.404.subtitle': 'Page Not Found',
  'error.404.message': 'The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.',
  'error.500.title': '500',
  'error.500.subtitle': 'Internal Server Error',
  'error.500.message': 'Something went wrong on our end. Please try refreshing the page or come back later.',
  'error.backHome': 'Back to Home',
  'error.tryAgain': 'Try Again',
};
